import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['PqIndex'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postPqIndexCalculatePqIndicesDeviceParameter: build.query<
        PostPqIndexCalculatePqIndicesDeviceParameterApiResponse,
        PostPqIndexCalculatePqIndicesDeviceParameterApiArg
      >({
        query: (queryArg) => ({
          url: `/PqIndex/calculate-pq-indices-device-parameter`,
          method: 'POST',
          body: queryArg.apiControllersPqIndexParameters,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            limitSetId: queryArg.limitSetId,
            measurementParameterGrouping: queryArg.measurementParameterGrouping,
            measurementDeviceGrouping: queryArg.measurementDeviceGrouping,
          },
        }),
        providesTags: ['PqIndex'],
      }),
      postPqIndexCalculatePqIndicesParameterTime: build.query<
        PostPqIndexCalculatePqIndicesParameterTimeApiResponse,
        PostPqIndexCalculatePqIndicesParameterTimeApiArg
      >({
        query: (queryArg) => ({
          url: `/PqIndex/calculate-pq-indices-parameter-time`,
          method: 'POST',
          body: queryArg.apiControllersPqIndexParameters,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            limitSetId: queryArg.limitSetId,
            measurementParameterGrouping: queryArg.measurementParameterGrouping,
            timeGrouping: queryArg.timeGrouping,
          },
        }),
        providesTags: ['PqIndex'],
      }),
      postPqIndexCalculatePqIndicesDeviceTime: build.query<
        PostPqIndexCalculatePqIndicesDeviceTimeApiResponse,
        PostPqIndexCalculatePqIndicesDeviceTimeApiArg
      >({
        query: (queryArg) => ({
          url: `/PqIndex/calculate-pq-indices-device-time`,
          method: 'POST',
          body: queryArg.apiControllersPqIndexParameters,
          params: {
            from: queryArg['from'],
            to: queryArg.to,
            limitSetId: queryArg.limitSetId,
            timeGrouping: queryArg.timeGrouping,
            measurementDeviceGrouping: queryArg.measurementDeviceGrouping,
          },
        }),
        providesTags: ['PqIndex'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as pqIndexApi };
export type PostPqIndexCalculatePqIndicesDeviceParameterApiResponse =
  /** status 200 OK */ ApiApplicationServicesDataTypesPqIndexTypesPqIndex[][];
export type PostPqIndexCalculatePqIndicesDeviceParameterApiArg = {
  /** The interval start for which the pq indices shall be calculated */
  from?: string;
  /** The interval end for which the pq indices shall be calculated */
  to?: string;
  /** The limit set which should be used for calculating the pq indices */
  limitSetId?: number;
  /** Specifies additional grouping options */
  measurementParameterGrouping?: ApiControllersDataTypesMeasurementParameterGrouping;
  /** Specifies additional grouping options */
  measurementDeviceGrouping?: ApiControllersDataTypesMeasurementDeviceGrouping;
  /** Additional parameters transferred via body (MeasurementDeviceIds and
    MeasurementParameterIds) */
  apiControllersPqIndexParameters: ApiControllersPqIndexParameters;
};
export type PostPqIndexCalculatePqIndicesParameterTimeApiResponse =
  /** status 200 OK */ ApiApplicationServicesDataTypesPqIndexTypesPqIndex[][];
export type PostPqIndexCalculatePqIndicesParameterTimeApiArg = {
  /** The interval start for which the pq indices shall be calculated */
  from?: string;
  /** The interval end for which the pq indices shall be calculated */
  to?: string;
  /** The limit set which should be used for calculating the pq indices */
  limitSetId?: number;
  /** Specifies additional grouping options */
  measurementParameterGrouping?: ApiControllersDataTypesMeasurementParameterGrouping;
  /** Specifies additional grouping options */
  timeGrouping?: ApiControllersDataTypesTimeGrouping;
  /** Additional parameters transferred via body (MeasurementDeviceIds and
    MeasurementParameterIds) */
  apiControllersPqIndexParameters: ApiControllersPqIndexParameters;
};
export type PostPqIndexCalculatePqIndicesDeviceTimeApiResponse =
  /** status 200 OK */ ApiApplicationServicesDataTypesPqIndexTypesPqIndex[][];
export type PostPqIndexCalculatePqIndicesDeviceTimeApiArg = {
  /** The interval start for which the pq indices shall be calculated */
  from?: string;
  /** The interval end for which the pq indices shall be calculated */
  to?: string;
  /** The limit set which should be used for calculating the pq indices */
  limitSetId?: number;
  /** Specifies additional grouping options */
  timeGrouping?: ApiControllersDataTypesTimeGrouping;
  /** Specifies additional grouping options */
  measurementDeviceGrouping?: ApiControllersDataTypesMeasurementDeviceGrouping;
  /** Additional parameters transferred via body (MeasurementDeviceIds and
    MeasurementParameterIds) */
  apiControllersPqIndexParameters: ApiControllersPqIndexParameters;
};
export type ApiApplicationServicesDataTypesPqIndexTypesPqIndex = {
  index?: number | null;
  measurementDeviceId?: number;
  measurementParameterId?: number;
  weekStart?: string;
};
export type ApiControllersDataTypesMeasurementParameterGrouping = 0 | 1;
export type ApiControllersDataTypesMeasurementDeviceGrouping = 0 | 1 | 2;
export type ApiControllersPqIndexParameters = {
  /** Id of the devices for which the data should be retrieved */
  measurementDeviceIds?: number[] | null;
  /** Id of the parameters for which the data should be retrieved */
  measurementParameterIds?: number[] | null;
};
export type ApiControllersDataTypesTimeGrouping = 0 | 1 | 2 | 3;
export const {
  usePostPqIndexCalculatePqIndicesDeviceParameterQuery,
  useLazyPostPqIndexCalculatePqIndicesDeviceParameterQuery,
  usePostPqIndexCalculatePqIndicesParameterTimeQuery,
  useLazyPostPqIndexCalculatePqIndicesParameterTimeQuery,
  usePostPqIndexCalculatePqIndicesDeviceTimeQuery,
  useLazyPostPqIndexCalculatePqIndicesDeviceTimeQuery,
} = injectedRtkApi;
